/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { Accordion } from '../../../molecules/Accordion/Accordion';
import { Tag } from '../../../atoms/Tag/Tag';
import { Text } from '../../../atoms/Text/Text';
import { TreeView } from '../../../molecules/TreeView/TreeView';
import './ToolProgressRendererStyles.scss';
const BASE_CLASS = 'tool-progress-renderer';
export function ToolProgressRenderer({ block }) {
    const progress = block;
    const treeItems = progress.steps.map((step) => ({
        id: step.step_id,
        label: step.label,
        detail: step.detail,
        status: step.status
    }));
    const title = (React.createElement("div", { className: `${BASE_CLASS}__title` },
        React.createElement(Tag, { label: progress.agent.display_name, variant: "gray", colorStyle: "solid", readOnly: true, icon: progress.agent.icon }),
        React.createElement(Text, { variant: "xx-small", className: `${BASE_CLASS}__task-label` }, progress.task_label)));
    return (React.createElement("div", { className: BASE_CLASS },
        React.createElement(Accordion, { variant: "section", title: title, defaultExpanded: !progress.is_complete },
            React.createElement(TreeView, { items: treeItems }))));
}
